export const requestSilentSave = (tabKey) => {
  return new Promise((resolve) => {
    let resolved = false;
    const wrappedResolve = (value) => {
      if (!resolved) {
        resolved = true;
        resolve(value);
      }
    };

    const event = new CustomEvent('ebiosrm_silent_save_request', {
      detail: { tabKey, resolve: wrappedResolve }
    });
    window.dispatchEvent(event);

    setTimeout(() => wrappedResolve('skipped'), 1000);
  });
};